const HASH_APP_PREFIX = '#/';

/**
 * @param {string} hashPath
 * @returns {boolean}
 */
const isSafeAppHashPath = hashPath => {
  if (typeof hashPath !== 'string' || hashPath.length === 0) {
    return false;
  }
  const lower = hashPath.toLowerCase();
  const badSchemeToken = `${'java'}${'script'}:`;
  const vbToken = `${'vb'}${'script'}:`;
  if (lower.includes(badSchemeToken) || lower.includes(vbToken)) {
    return false;
  }
  if (hashPath.startsWith('//')) {
    return false;
  }
  if (hashPath.includes('://')) {
    return false;
  }
  if (!hashPath.startsWith('#')) {
    return false;
  }
  for (let i = 0; i < hashPath.length; i += 1) {
    const code = hashPath.charCodeAt(i);
    if (code < 0x20 || code === 0x7f) {
      return false;
    }
  }
  return hashPath.startsWith(HASH_APP_PREFIX);
};

/**
 * @param {string} hashPath
 * @returns {string|null}
 */
const safeAppHashLink = hashPath => isSafeAppHashPath(hashPath) ? hashPath : null;
export { isSafeAppHashPath, safeAppHashLink };